import { useState, useEffect } from 'react';

// Module-level cache — fetched once per page load, retried on failure
let cachedLogo = null;
let fetchPromise = null;

export function useLogo() {
  const [logoUrl, setLogoUrl] = useState(cachedLogo);

  useEffect(() => {
    if (cachedLogo) { setLogoUrl(cachedLogo); return; }
    if (!fetchPromise) {
      fetchPromise = fetch('/api/site-settings')
        .then(r => r.json())
        .then(d => {
          cachedLogo = d?.logo_url || null;
          return cachedLogo;
        })
        .catch(() => {
          // Reset so the next component mount retries the fetch
          fetchPromise = null;
          return null;
        });
    }
    fetchPromise.then(url => setLogoUrl(url));
  }, []);

  return logoUrl;
}
